// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* Estilos básicos para el wizard */\n.wizard .nav-tabs {\r\n    border-bottom: 2px solid #ddd;\n}\n.wizard .nav-item .nav-link.active {\r\n    background-color: #007bff;\r\n    color: white;\n}\r\n", ""]);
// Exports
module.exports = exports;
